import { Popover } from '@gympass/yoga';
import { useIntl } from 'react-intl';

import { TooltipProps } from './types';

const Tooltip: React.FC<TooltipProps> = ({
  children,
  title,
  width = 265,
  height = 200,
  description,
  available = true,
  position = 'top-center',
}) => {
  const { formatMessage } = useIntl();

  const handleDescription = () => {
    if (description && typeof description === 'string') {
      return formatMessage({
        id: description,
      });
    }
    if (description && Array.isArray(description)) {
      return description
        ?.map(text =>
          formatMessage({
            id: text,
          }),
        )
        .join(',\n');
    }
    return '';
  };

  if (!available || !description) {
    return <>{children}</>;
  }

  return (
    <Popover
      width={width}
      height={height}
      position={position}
      data-testid="tooltip"
      style={{ zIndex: 2 }}
      title={
        title
          ? formatMessage({
              id: title,
            })
          : ''
      }
      description={handleDescription()}
    >
      {children}
    </Popover>
  );
};

export default Tooltip;
